import { render, staticRenderFns } from "./WeaponsModalSelect.vue?vue&type=template&id=70186c1a&scoped=true&"
import script from "./WeaponsModalSelect.vue?vue&type=script&lang=js&"
export * from "./WeaponsModalSelect.vue?vue&type=script&lang=js&"
import style0 from "./WeaponsModalSelect.vue?vue&type=style&index=0&id=70186c1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70186c1a",
  null
  
)

export default component.exports